import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { Paginated, PaginationQuery } from "../../types";
import useApi, { buildUrl } from "../api";
import { CustomError } from "../errors";
import { InsertProcessingRequestHistory, ProcessingRequestHistory } from "./types";

const useProcessingRequestHistoryApi = () => {
  const baseurl = "/request_history";
  const requestUrl = "/processing_requests";
  const api = useApi();

  const useProcessingRequestHistories = useCallback(
    (id: number, query: PaginationQuery) => {
      const url = buildUrl(`${requestUrl}/${id + baseurl}`, query);

      const result = useQuery<Paginated<ProcessingRequestHistory>, CustomError>({
        queryKey: [url],
        queryFn: ({ signal }) => api.get<Paginated<ProcessingRequestHistory>>({ url, signal }),
      });
      return { ...result, error: result.error ?? undefined };
    },
    [api]
  );

  const createProcessingRequestHistory = useCallback(
    async (requestHistory: InsertProcessingRequestHistory) => {
      const data = await api.post<InsertProcessingRequestHistory, ProcessingRequestHistory>(
        `${requestUrl}/${requestHistory.processingRequestId + baseurl}`,
        requestHistory
      );
      api.mutateCache([requestUrl + "/" + requestHistory.processingRequestId + baseurl]);
      return data;
    },
    [api]
  );

  return {
    useProcessingRequestHistories,
    createProcessingRequestHistory,
  };
};

export default useProcessingRequestHistoryApi;
